import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal, Chapter } from "../components/Reveal";
import { CtaSection } from "./Home";
import { SiteImg } from "../hooks/useSiteImages";
import { T } from "../hooks/useSiteTexts";
import { IMAGES, SERVICES } from "../data/content";

export default function Servicos() {
    return (
        <>
            <PageHero
                overline="Serviços"
                title="Soluções de transporte"
                accent="à medida."
                subtitle={<T k="servicos-hero-sub" fallback="Do transporte de inertes ao transporte internacional — capacidade, flexibilidade e rigor em cada operação." />}
                image={IMAGES.construction}
                slot="servicos-hero"
            />

            <section className="mx-auto max-w-7xl px-6 py-28 lg:px-10" data-testid="services-detail">
                {SERVICES.map((s, i) => (
                    <div
                        key={s.id}
                        id={s.id}
                        className={`grid items-center gap-12 py-16 lg:grid-cols-2 lg:gap-20 ${
                            i > 0 ? "border-t border-white/10" : ""
                        }`}
                        data-testid={`service-detail-${s.id}`}
                    >
                        <Reveal className={i % 2 === 1 ? "lg:order-2" : ""}>
                            <Chapter num={i + 1} label="Serviço" />
                            <h2 className="mt-8 font-display text-3xl font-black uppercase leading-tight tracking-tight sm:text-4xl">
                                {s.title}
                            </h2>
                            <p className="mt-6 max-w-lg text-sm leading-relaxed text-zinc-400 md:text-base">
                                <T k={`service-long-${s.id}`} fallback={s.long} />
                            </p>
                            {s.extra && (
                                <p className="mt-4 max-w-lg text-sm leading-relaxed text-zinc-400 md:text-base">
                                    <T k={`service-extra-${s.id}`} fallback={s.extra} />
                                </p>
                            )}
                            <ul className="mt-8 space-y-3">
                                {s.features.map((f) => (
                                    <li
                                        key={f}
                                        className="flex items-start gap-3 text-sm text-zinc-300"
                                    >
                                        <Check className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
                                        {f}
                                    </li>
                                ))}
                            </ul>
                            <Link
                                to="/contactos"
                                data-testid={`service-quote-${s.id}`}
                                className="group mt-10 inline-flex items-center gap-3 border border-white/25 px-7 py-3.5 font-mono text-[11px] font-bold uppercase tracking-[0.2em] text-white transition-colors duration-300 hover:border-brand hover:text-brand"
                            >
                                Pedir orçamento
                                <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                            </Link>
                        </Reveal>
                        <Reveal delay={0.15} className={i % 2 === 1 ? "lg:order-1" : ""}>
                            <div className="group overflow-hidden border border-white/10">
                                <SiteImg
                                    slot={`service-${s.id}`}
                                    fallback={s.image}
                                    alt={s.title}
                                    loading="lazy"
                                    className="aspect-[16/10] w-full object-cover transition-transform duration-700 group-hover:scale-105"
                                />
                            </div>
                        </Reveal>
                    </div>
                ))}
            </section>

            <CtaSection />
        </>
    );
}
